<script lang="ts">
	import { Link } from 'svelte-routing';
	export let title = '';
	export let subtitle = '';
	export let logo = true;
</script>

<div class="login">
	<div class="headlines">
		<Link to="/">
			{#if logo}
				<img class="logo" src="/assets/icons/android-chrome-512x512.png" alt="AdPicker logo" />
			{/if}
			<div class="text mdc-typography--headline2">{title || ''}</div>
		</Link>
		<div class="text mdc-typography--headline4">{subtitle || ''}</div>
	</div>
	<slot />
</div>

<style>
	.login {
		display: flex;
		flex-direction: column;
		min-height: 350px;
		/* justify-content: space-between; */
		align-items: center;
		text-align: center;
	}
	.text {
		margin-bottom: 16px;
		color: var(--text-color);
	}

	.headlines {
		margin-bottom: 24px;
	}
	img {
		max-width: 200px;
	}
</style>
